import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-my-library",
  "use": "icon-my-library-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-my-library\"><path d=\"M98.1 168.9h827.7v90.7H98.1zM169 79.1h686v72.4H169zM15.9 277v669H1008V277H15.9z m359.9 526V410l328.5 205.5L375.8 803z\" fill=\"#ffffff\" p-id=\"9527\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol